<template>
    <div class="layout-contents">
        <div class="box-container custom-box" data-size-to-fit>
            <fieldset class="tbl-filters">
                <legend>table filters</legend>
                <div class="seperate">
                    <div class="datepicker">
                        <input type="text" name="rangedates">
                    </div>
                </div>
            </fieldset>
            <div-loading v-if="pending" :full="true"></div-loading>
            <!-- improvements -->
            <div class="tbl-collapse" data-linkable-row>
                <div class="thead">
                    <div class="row">
                        <span class="cell" data-size="status" data-align="center">
                            <button type="button" class="buttons-tbl-header" data-type="filter" data-tooltip-content="#tooltip-filter">{{ $t('AUDIT.LABEL.HEADER.STATUS')}}<!--상태--></button>
                            <div class="tooltip_templates">
                                <div id="tooltip-filter">
                                    <ul class="list-filter">
                                        <li>
                                            <input type="checkbox"
                                                id="filter-error"
                                                name="filter-type"
                                                class="checkbox"
                                                v-model="searchAction"
                                                value="error">
                                            <label for="filter-error">{{$t('COMPLIANCE.EVAL_STAT.ERROR')}}</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </span>
                        <span class="cell" data-size="date">
                            <button type="button" class="buttons-tbl-header"
                                    v-bind:data-type="sortColumn !== 'timeLine' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                    v-on:click="setSortColumn('timeLine')">{{ $t('AUDIT.LABEL.HEADER.DATE')}}<!--일시--></button>
                        </span>
                        <span class="cell" data-size="type">
                            {{ $t('AUDIT.LABEL.HEADER.ACTIVITY_TYPE')}}<!--활동 유형-->
                        </span>
                        <span class="cell" data-size="user">
                            <button type="button" class="buttons-tbl-header" data-type="filter1" data-tooltip-content="#tooltip-filter1">{{ $t('AUDIT.LABEL.HEADER.USER')}}<!--사용자--></button>
                            <div class="tooltip_templates">
                                <div id="tooltip-filter1">
                                    <ul class="list-filter">
                                        <li>
                                            <input type="checkbox" id="filter-system" name="filter-type" class="checkbox" v-model="searchAction" value="System">
                                            <label for="filter-system">System</label>
                                        </li>
                                        <li>
                                            <input type="checkbox" id="filter-user" name="filter-type" class="checkbox" v-model="searchAction" value="user">
                                            <label for="filter-user">{{$t('AUDIT.LABEL.HEADER.USER')}}</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </span>
                        <span class="cell">
                            {{ $t('AUDIT.LABEL.HEADER.DESCRIPTION')}}<!--상세 내용-->
                        </span>
                        <span class="cell" data-align="center">
                            {{ $t('AUDIT.LABEL.HEADER.DETAILS')}}<!--상세-->
                        </span>
                    </div>
                </div>

                <div class="tbody">
                    <!-- 규칙 -->
                    <template v-for="(hist, idx) of getintegrationHistoryList">
                        <expand-policy-create v-if="hist.histType === constants.HIST_TYPE.POLICY_CREATE || hist.histType === constants.HIST_TYPE.POLICY_DELETE || hist.histType === constants.HIST_TYPE.POLICY_COPY" :="hist" :key="idx"></expand-policy-create>
                        <expand-policy-modify v-if="hist.histType === constants.HIST_TYPE.POLICY_MODIFY" :hist-item="hist" :key="idx"></expand-policy-modify>
                        <expand-rule-create v-if="hist.histType === constants.HIST_TYPE.RULE_CREATE || hist.histType === constants.HIST_TYPE.RULE_DELETE || hist.histType === constants.HIST_TYPE.RULE_COPY" :hist-item="hist" :ctg-list="ctgList" :actn-tmplt-list="actnTmpltList" :key="idx"></expand-rule-create>
                        <expand-rule-modify v-if="hist.histType === constants.HIST_TYPE.RULE_MODIFY" :hist-item="hist" :ctg-list="ctgList" :actn-tmplt-list="actnTmpltList" :key="idx"></expand-rule-modify>
                        <expand-whiteList-create v-if="hist.histType === constants.HIST_TYPE.WHITELIST_CREATE" :hist-item="hist" :key="idx"></expand-whiteList-create>
                        <expand-whiteList-modify v-if="hist.histType === constants.HIST_TYPE.WHITELIST_MODIFY" :hist-item="hist" :key="idx"></expand-whiteList-modify>
                        <expand-inspection-create v-if="hist.histType === constants.HIST_TYPE.INSPECTION_ADD" :hist-item="hist" :key="idx"></expand-inspection-create>
                        <expand-inspection-update v-if="hist.histType === constants.HIST_TYPE.INSPECTION_UPDATE" :hist-item="hist" :key="idx"></expand-inspection-update>
                        <expand-compliance-start v-if="hist.histType === constants.HIST_TYPE.COMPLIANCE_START" :hist-item="hist" :common-info-val="commonInfoVal" :key="idx"></expand-compliance-start>
                        <expand-action-execute v-if="hist.histType === constants.HIST_TYPE.ACTION_EXECUTE" :hist-item="hist" :key="idx"></expand-action-execute>
                    </template>
                    <div class="row none with-button" v-if="!pending && getintegrationHistoryList.length === 0">
                        <div class="cells">
                            <div class="cell">
                                {{$t('COMMON.NO_DATA')}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Pagination
            :callSetCurPage="setCurrentPage"
            :callSetRowsPerPage="setRowsPerPage"
            :totalPage="paging.totalPage"
            :currentPage="paging.currentPage"
            :rowsPerPage="paging.rowsPerPage"
        />
    </div>
</template>

<script>
    import Pagination from "../common/Pagination.vue";
    import ExpandPolicyCreate from "../../components/audit/expand/policyCreate.vue";
    import ExpandComplianceStart from "../../components/audit/expand/complianceStart.vue";
    import ExpandInspectionCreate from "../../components/audit/expand/inspectionCreate.vue";
    import ExpandInspectionUpdate from "../../components/audit/expand/inspectionUpdate.vue";
    import ExpandPolicyModify from "../../components/audit/expand/policyModify.vue";
    import ExpandRuleCreate from "../../components/audit/expand/ruleCreate.vue";
    import ExpandRuleModify from "../../components/audit/expand/ruleModify.vue";
    import ExpandActionExecute from "../../components/audit/expand/actionExecute.vue";
    import ExpandWhiteListCreate    from "../../components/audit/expand/whiteListCreate.vue";
    import ExpandWhiteListModify    from "../../components/audit/expand/whiteListModify.vue";
    import {mapGetters} from "vuex";

    export default {
        name: 'ComplianceDetailTabHistory',
        props:['plcyRvsnId', 'plcyId'],
        components:{
            'expand-policy-create'      : ExpandPolicyCreate,
            'expand-policy-modify'      : ExpandPolicyModify,
            'expand-rule-create'        : ExpandRuleCreate,
            'expand-rule-modify'        : ExpandRuleModify,
            'expand-whiteList-create'   : ExpandWhiteListCreate,
            'expand-whiteList-modify'   : ExpandWhiteListModify,
            'expand-inspection-create'  : ExpandInspectionCreate,
            'expand-inspection-update'  : ExpandInspectionUpdate,
            'expand-compliance-start'   : ExpandComplianceStart,
            'expand-action-execute'     : ExpandActionExecute,
            Pagination
        },
        data() {
            return {
                cmplId: this.$route.query.cmpl            // Current company ID
                , rsltId: this.$route.query.rslt            // Compliance Result ID
                , rvsnId: this.$route.query.rvsn,
                historyresultList: []
                , pending: false
                , sortColumn: ''                                // Sort column
                , sortOrder: ''                                 // Sort order
                , searchAction:[]
                , filter: {
                    arrHistType: [],
                    stDt: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                    endDt: moment(new Date()).format('YYYY-MM-DD')
                }, paging: {
                    totalItem: 0,
                    currentPage: 1,
                    rowPerPage: this.constants.NUM.ROW_PER_PAGE,
                    totalPage: 0
                },
                commonInfoVal: {},
                actnTmpltList: [],
                ctgList: [],
                integrationHistoryList: [],
            }
        },
        created() {
            this.debounceGetAssessmentLog = _.debounce(this.getIntegrationHistoryList, 900);
        },
        mounted() {
            this.commonInfo();
            this.getIntegrationHistoryList();
            let self = this;
            $('input[name="rangedates"]').daterangepicker({
                "autoApply": true,
                startDate: moment(self.filter.stDt),
                endDate: moment(self.filter.endDt),
                locale: {
                    format: 'MM/DD/YYYY',
                    "daysOfWeek": ["Sun","Mon","Tue","Wen","Thu","Fri","Sat"],
                }
            }, function(start, end, label) {
                self.filter.stDt = start.format('YYYY-MM-DD');
                self.filter.endDt = end.format('YYYY-MM-DD');
                self.debounceGetAssessmentLog();
            });
            const $filterTarget = $('.buttons-tbl-header[data-type=filter]');
            const $filterTarget1 = $('.buttons-tbl-header[data-type=filter1]');
            $filterTarget.tooltipster({
                animation: 'fade',
                delay: 200,
                side: 'bottom',
                theme: 'go-filter',
                interactive: true,
                trigger: 'click',
                functionBefore: function(instance, helper) {
                    $filterTarget.addClass("selected");
                },
                functionAfter: function(instance, helper) {
                    $filterTarget.removeClass("selected");
                },
            });
            $filterTarget1.tooltipster({
                animation: 'fade',
                delay: 200,
                side: 'bottom',
                theme: 'go-filter',
                interactive: true,
                trigger: 'click',
                functionBefore: function(instance, helper) {
                    $filterTarget1.addClass("selected");
                },
                functionAfter: function(instance, helper) {
                    $filterTarget1.removeClass("selected");
                },
            });
        },
        computed: {
            getintegrationHistoryList: function() {
                let list = this.integrationHistoryList;

                return list!= null ? list : [];
            },
            ...mapGetters({
                curCmpnId: 'user/curCmpnId',
            }),
            getLocale() {
                return this.$i18n.locale;
            },
            getHistoryResultList: function () {
                let self = this;
                let listInfo = this.historyresultList;

                // Sorting 처리
                if (this.sortColumn !== '' && this.sortOrder !== '') {
                    // console.log("sortc : ", this.sortColumn, "order:",this.sortOrder)
                    listInfo = _.orderBy(listInfo, [self.sortColumn], [self.sortOrder]);
                }

                // state filter 적용
                if(this.searchAction != null && this.searchAction.length > 0){
                    listInfo = _.forEach(listInfo, function(e){
                        delete e.filterValue;
                    })

                    listInfo = _.filter(listInfo, function(e){
                        if(_.includes(self.searchAction, 'System') && e.creaNm === 'System'){
                            e.filterValue = 'Y' ;
                        }
                        if(_.includes(self.searchAction, 'user') && e.creaNm !== 'System'){
                            e.filterValue = 'Y' ;
                        }
                        if(_.includes(self.searchAction, 'error') && e.cmplStat === 'E'){
                            e.filterValue = 'Y' ;
                        }
                        return e.filterValue === 'Y';
                    })
                }
                return listInfo;
            }
        },
        watch:  {
            curCmpnId() {
                this.$router.push(`/compliance`);
            },
            searchAction() {
                this.debounceGetAssessmentLog();
            }
        },
        methods: {
            commonInfo() {
                const url = "/api/governance/compliance/common/info";
                const header = {
                    'cmpnId': this.curCmpnId,
                    'cmplId': this.cmplId,
                    'rsltId': this.rsltId
                }
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        this.commonInfoVal = result.data;
                    });
            },
            async getIntegrationHistoryList() {
                this.pending = true;
                const url = "/api/governance/audit/list";
                const header = {
                    'cmpnId': this.curCmpnId,
                    'cmplId': this.cmplId,
                    'rsltId': this.rsltId,
                    'rvsnId': this.plcyId,
                    'stDt': this.filter.stDt,
                    'endDt': this.filter.endDt,
                    'sortColumn' : this.sortColumn,
                    'sortOrder': this.sortOrder,
                    'rowPerPage': this.paging.rowPerPage,
                    'currentPage': this.paging.currentPage,
                    'statusFilter': this.searchAction,
                };
                try {
                    const response = await this.http.post(url, JSON.stringify(header));
                    this.integrationHistoryList = response.data.result;
                    this.paging = response.data.pagination;
                } catch (err) {
                    console.error(err);
                } finally {
                    this.pending = false;
                }
            },
            setCurrentPage(page) {
                this.paging.currentPage = page;
                this.debounceGetAssessmentLog();
            },
            convertUtcTimezoneToLocal: function(date) {
                return this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale);
            },
            initFilter: function() {
                var $filterTarget = $('.buttons-tbl-header[data-type=filter]');
                $filterTarget.tooltipster({
                    animation: 'fade',
                    delay: 200,
                    side: 'bottom',
                    theme: 'go-filter',
                    interactive: true,
                    trigger: 'click',
                    functionBefore: function(instance, helper) {
                        $filterTarget.addClass("selected");
                    },
                    functionAfter: function(instance, helper) {
                        $filterTarget.removeClass("selected");
                    },
                });
            },
            // 선택한 Column으로 Rule 리스트 Sorting
            setSortColumn(sortColumn) {
                const sortObject = this.Common.setSortColumn(this.sortColumn, this.sortOrder, sortColumn);
                this.sortColumn = sortObject.sortColumn;
                this.sortOrder = sortObject.sortOrder
                this.debounceGetAssessmentLog();
            },
            setRowsPerPage(rpp) {
                this.paging.rowPerPage = rpp.rowsPerPage;
                this.paging.currentPage = rpp.currentPage;
                this.debounceGetAssessmentLog();
            },
        }

    }
</script>
<style scoped>
.custom-pagination.-pagination {
    position: inherit;
}
.box-container.custom-box {
    border: none;
    background-color: #f5f5f7
}
.buttons-tbl-header[data-type="filter1"]:after{
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='1024' height='1024' fill='rgb%28176%2C183%2C191%29'%3E%3Cpath d='M757.822 213.334h-492.57c-3.36-.006-6.459 1.71-8.091 4.48s-1.539 6.159.242 8.847L442.094 503.3c4.636 6.938 7.1 14.969 7.111 23.169v266.777c0 9.621 8.269 17.421 18.469 17.421h88.652c10.2 0 18.469-7.799 18.469-17.421V526.469c.01-8.201 2.475-16.232 7.111-23.169l184.691-276.639c1.781-2.688 1.873-6.076.242-8.847s-4.731-4.487-8.091-4.48h-.923z'/%3E%3C/svg%3E");
}
.buttons-tbl-header[data-type="filter1"].selected:after,
.buttons-tbl-header[data-type="filter1"]:active:after {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='1024' height='1024' fill='rgb%286%2C114%2C255%29'%3E%3Cpath d='M757.822 213.334h-492.57c-3.36-.006-6.459 1.71-8.091 4.48s-1.539 6.159.242 8.847L442.094 503.3c4.636 6.938 7.1 14.969 7.111 23.169v266.777c0 9.621 8.269 17.421 18.469 17.421h88.652c10.2 0 18.469-7.799 18.469-17.421V526.469c.01-8.201 2.475-16.232 7.111-23.169l184.691-276.639c1.781-2.688 1.873-6.076.242-8.847s-4.731-4.487-8.091-4.48h-.923z'/%3E%3C/svg%3E");
}
</style>



// WEBPACK FOOTER //
// src/components/compliance/complianceDetailTabHistory.vue